import { Span } from "@components/ui/typograhpy/Span"
import { Text } from "@components/ui/typograhpy/Text"
import { Currency } from "@generated"
import { cn } from "@lib/cn"
import React, { FC } from "react"

const CURRENCY_OPTIONS: { code: Currency; label: string; symbol: string }[] = [
  { code: Currency.Usd, label: "US Dollar", symbol: "$" },
  { code: Currency.Eur, label: "Euro", symbol: "€" },
]

type CurrencyDropdownProps = {
  selectedCurrency: Currency
  onSelect: (currency: Currency) => void
}

export const CurrencyDropdown: FC<CurrencyDropdownProps> = ({
  selectedCurrency,
  onSelect,
}) => {
  return (
    <div className="w-full px-4 py-3">
      <Text variant="small" className="text-shade-500 mb-3">
        Select currency
      </Text>
      <div className="space-y-1">
        {CURRENCY_OPTIONS.map((option) => {
          const isActive = option.code === selectedCurrency
          return (
            <button
              key={option.code}
              type="button"
              className={cn(
                "flex w-full items-center justify-between rounded px-3 py-2 text-left",
                "transition-colors duration-150",
                isActive
                  ? "bg-border-opacity text-foreground"
                  : "hover:bg-border-opacity/60 text-shade-500",
              )}
              onClick={() => onSelect(option.code)}
            >
              <div>
                <Span variant="button-label-small" className="block">
                  {option.symbol} {option.code}
                </Span>
                <Text variant="small" className="text-shade-500">
                  {option.label}
                </Text>
              </div>
              {isActive && (
                <Span
                  aria-hidden
                  className="text-variant-purple ml-2 text-xs font-semibold"
                  variant="button-label-small"
                >
                  Selected
                </Span>
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}
